























































import { Component, Vue } from "vue-property-decorator";
import { RecipeItem, AlertItem, DialogItem } from "@/response";
import { ActionTypes } from "@/store/aciton-types";

export interface ConfirmDialogItem {
  status: string;
  title: string;
  msg: string;
  hasConfirmButton: boolean;
  hasCancelButton: boolean;
  callback: any;
}

@Component
export default class DialogComponent extends Vue {
  // showComfirmDialog: boolean = false;
  // confirmDialogDisplay = "none";
  // confirmDialog: ConfirmDialogItem = {
  //   status: "",
  //   title: "",
  //   msg: "",
  //   hasConfirmButton: false,
  //   hasCancelButton: false,
  //   callback: () => {
  //     return;
  //   }
  // };

  // openConfirmDialog() {
  //   this.showComfirmDialog = true;
  //   this.confirmDialogDisplay = "block";
  // }

  // closeConfirmDialog() {
  //   this.showComfirmDialog = false;
  //   this.confirmDialogDisplay = "none";
  // }

  get dialog() {
    try {
      if (<boolean>this.$store.state.dialog.show) {
        return <DialogItem>this.$store.state.dialog;
      }
      throw Error;
    } catch (error) {
      return <DialogItem>{
        show: false,
        status: "",
        title: "",
        msg: "",
        hasConfirmButton: false,
        hasCancelButton: false,
        callback: () => {
          return;
        }
      };
    }
  }

  closeDialog() {
    this.$store.dispatch(ActionTypes.CLOSE_DIALOG);
  }

  beforeMount() {}
}
